import React from 'react';
import { Text, Box, Grid } from '../core';
import {
  aprToApy,
  toBN,
  aprToLoss,
  formatPercentageBN,
} from '@sc1/common/utils';
import { Strategy, Vault } from '@sc1/common/gql/types';
import { IIcons, MouseoverTooltipContent, TooltipIcon } from '../Tooltip';

interface YieldStatProps {
  data?: Partial<Vault> | Partial<Strategy> | null;
}

const BASIS = 4;

export const YieldStat = ({ data }: YieldStatProps): JSX.Element => {
  const dec = data?.decimals;
  const aprDaily = formatPercentageBN(data?.aprDaily, BASIS);
  const aprThreeDay = formatPercentageBN(data?.aprThreeDay, BASIS);
  const aprWeekly = formatPercentageBN(data?.aprWeekly, BASIS);
  // const aprMonthly = formatPercentageBN(data?.aprMonthly, BASIS);
  // const aprYearly = formatPercentageBN(data?.aprYearly, BASIS);
  // const aprAllTime = formatPercentageBN(data?.aprAllTime, BASIS);
  // const apyCurrent = aprToApy(data?.aprCurrent, BASIS);
  const apyDaily = aprToApy(data?.aprDaily, BASIS);
  const apyThreeDay = aprToApy(data?.aprThreeDay, BASIS);
  const apyWeekly = aprToApy(data?.aprWeekly, BASIS);
  // const apyMonthly = aprToApy(data?.aprMonthly, BASIS);
  // const apyYearly = aprToApy(data?.aprYearly, BASIS);
  // const apyAllTime = aprToApy(data?.aprAllTime, BASIS);
  const maxApr = [data?.aprDaily, data?.aprThreeDay].sort(
    (a, b) => Number(b) - Number(a)
  )[0];
  const maxApy = aprToApy(maxApr, BASIS);

  const lossDaily = aprToLoss(data?.aprDaily, BASIS);
  const lossThreeDay = aprToLoss(data?.aprThreeDay, BASIS);
  const lossWeekly = aprToLoss(data?.aprWeekly, BASIS);

  const isProfit = maxApr && toBN(maxApr)?.gt(0);

  return (
    <Box sx={{ flex: 1 }}>
      <MouseoverTooltipContent
        wrap={true}
        width="auto"
        content={
          data ? (
            <Grid
              sx={{ rowGap: 2, textAlign: 'right' }}
              columns={isProfit ? 'auto 1fr 1fr' : 'auto 1fr'}
            >
              {isProfit ? (
                <>
                  <Box />
                  <Box>APR</Box>
                  <Box>APY</Box>
                  <Box sx={{ textAlign: 'left' }}>1 Day Average</Box>
                  <Box>{aprDaily}</Box>
                  <Box>{apyDaily}</Box>
                  <Box sx={{ textAlign: 'left' }}>3 Day Average</Box>
                  <Box>{aprThreeDay}</Box>
                  <Box>{apyThreeDay}</Box>
                  <Box sx={{ textAlign: 'left' }}>7 Day Average</Box>
                  <Box>{aprWeekly}</Box>
                  <Box>{apyWeekly}</Box>
                  {/*
                  <Box sx={{ textAlign: 'left' }}>Monthly</Box>
                  <Box>{aprMonthly}</Box>
                  <Box>{apyMonthly}</Box>
                  <Box sx={{ textAlign: 'left' }}>Yearly</Box>
                  <Box>{aprYearly}</Box>
                  <Box>{apyYearly}</Box>
                  <Box sx={{ textAlign: 'left' }}>All Time</Box>
                  <Box>{aprAllTime}</Box>
                  <Box>{apyAllTime}</Box>
                  */}
                </>
              ) : (
                <>
                  <Box sx={{ textAlign: 'left' }}>1 Day Average</Box>
                  <Box>{lossDaily}</Box>
                  <Box sx={{ textAlign: 'left' }}>3 Day Average</Box>
                  <Box>{lossThreeDay}</Box>
                  <Box sx={{ textAlign: 'left' }}>7 Day Average</Box>
                  <Box>{lossWeekly}</Box>
                </>
              )}
            </Grid>
          ) : (
            <Text>Stats unavailable</Text>
          )
        }
      >
        {isProfit ? (
          <Text mr={1}>APY: {maxApy}</Text>
        ) : (
          <Text mr={1}>PNL: {lossDaily}</Text>
        )}
        <TooltipIcon icon={data ? IIcons.INFO : IIcons.HELP} />
      </MouseoverTooltipContent>
    </Box>
  );
};
